// OCSH = Office of Child Support Hearings
export const OCSH_PHONE_NUMBER = '(808) 692-7110' as string;
export const OCSH_URL = 'https://ag.hawaii.gov/ocsh/' as string;

// CSEA = Child Support Enforcement Agency
export const CSEA_HOMEPAGE_URL = 'https://ag.hawaii.gov/csea/' as string;
export const CSEA_CUSTOMER_SERVICE_URL = 'https://ag.hawaii.gov/csea/contact/' as string;
export const CSEA_ENFORCEMENTS_URL = 'https://ag.hawaii.gov/csea/enforcement/' as string;
